import { OnInit } from '@angular/core';
import { defaultHours } from '../../lead-generation/shared/domain/WorkingHours';
import { FormBuilder } from '@angular/forms';
import { createGroup, createRange } from './workingHoursFormCreator';
var WorkingHoursListComponent = /** @class */ (function () {
    function WorkingHoursListComponent(fb) {
        this.fb = fb;
    }
    WorkingHoursListComponent.prototype.ngOnInit = function () {
        this.disabledDays = this.work.ranges.reduce(function (disabled, range) { return disabled.concat(range.days); }, []);
        this.workingHoursFormWrapper.form = createGroup(this.work, this.work.timezone, this.fb);
    };
    WorkingHoursListComponent.prototype.onSelectionChanged = function (day) {
        var isAlreadyDisabled = this.disabledDays.includes(day);
        if (isAlreadyDisabled) {
            this.disabledDays = this.disabledDays.filter(function (d) { return d !== day; });
        }
        else {
            this.disabledDays = [day].concat(this.disabledDays);
        }
    };
    Object.defineProperty(WorkingHoursListComponent.prototype, "work", {
        get: function () {
            return this.configuration.workingHours;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkingHoursListComponent.prototype, "form", {
        get: function () {
            return this.workingHoursFormWrapper.form;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkingHoursListComponent.prototype, "ranges", {
        get: function () {
            return this.form.controls['ranges'];
        },
        enumerable: true,
        configurable: true
    });
    WorkingHoursListComponent.prototype.deleteRange = function (index) {
        var days = this.ranges.at(index).get('days').value.slice();
        this.ranges.removeAt(index);
        this.disabledDays = this.disabledDays.filter(function (day) { return !days.includes(day); });
    };
    Object.defineProperty(WorkingHoursListComponent.prototype, "workingHoursAreEnabled", {
        get: function () {
            return this.form.get('enabled').value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkingHoursListComponent.prototype, "allDaysAreDisabled", {
        get: function () {
            return this.disabledDays.length === 7;
        },
        enumerable: true,
        configurable: true
    });
    WorkingHoursListComponent.prototype.createNewRange = function () {
        var newRange = { hours: [defaultHours], days: [] };
        this.ranges.push(createRange(newRange, this.fb));
    };
    return WorkingHoursListComponent;
}());
export { WorkingHoursListComponent };
